"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClient = void 0;
const react_1 = require("react");
const provider_1 = require("../provider");
function useClient() {
    const kettingContext = react_1.useContext(provider_1.getKettingContext());
    if (!kettingContext.client) {
        throw new Error('To use useClient, you must have a <KettingProvider> component set up');
    }
    return kettingContext.client;
}
exports.useClient = useClient;
//# sourceMappingURL=use-client.js.map